// React's minified production error codes for a plain text-content hydration
// mismatch (418, and 425 for the same case inside a Suspense boundary) — React
// auto-recovers from these by discarding server HTML and re-rendering the
// affected subtree client-side. Deliberately narrower than the full family of
// hydration-related codes: 419/421 indicate something actually threw during
// SSR or a Suspense boundary was updated mid-hydration, and 422/423 are
// generic "error during hydration" wrappers that also fire for genuine
// app-code exceptions — none of those are safe to blanket-drop.
//
// The dominant real-world cause of 418/425 on public pages is a browser
// feature or extension (e.g. Chrome's built-in page translate) mutating DOM
// text nodes before React hydrates — not an app bug. Verified on
// marketbetter.ai: every occurrence traced to the homepage's own render tree
// was already correctly SSR/CSR-guarded, and the error volume was unaffected
// by adding `suppressHydrationWarning` to <body> (see #3512/#3513), which
// only guards mismatches one DOM level deep — confirming the actual mismatch
// happens deeper in the tree, where an extension can touch any text node on
// the page.
const HYDRATION_MISMATCH_ERROR_PATTERN = /Minified React error #(?:418|425);/;

export function isBenignHydrationMismatchNoise(message: string | undefined | null): boolean {
  if (!message) return false;
  return HYDRATION_MISMATCH_ERROR_PATTERN.test(message);
}
